import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";

import { FormInstance } from "antd/lib/form";
import { TIndexTypeCategoryPresentationModel } from "../../presenter/model/IndexTypeCategoryPresentationModel";
import TextArea from "antd/lib/input/TextArea";
import { IIndexTypeCategory } from "../../model/IndexTypeCategory";

const FormFields = {
  ID: "id",
  NAME: "name",
  CODE: "code",
  DESCRIPTION: "description",
  VALID: "valid"
};

const IndexTypeCategoryForm = ({
  translate,
  form,
  rowData,
  categoryCandidates,
  toggleCandidate
}: {
  translate: any;
  form: FormInstance;
  rowData?: TIndexTypeCategoryPresentationModel;
  categoryCandidates?: IIndexTypeCategory[];
  toggleCandidate?: any;
}) => {
  function renderCategoryCandidates() {
    return categoryCandidates?.map((candidate) => {
      return (
        <Form.Item
          label={candidate.name}
          className={"png-form-item-horizontal-checkbox mb-0"}
          initialValue={candidate.connected}
          style={{ marginLeft: "0.5em" }}
        >
          <Checkbox
            onChange={() => toggleCandidate(candidate)}
            checked={candidate.connected}
          />
        </Form.Item>
      );
    });
  }

  return (
    <Form layout={"vertical"} form={form}>
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col lg={22} sm={21} xs={20}>
          <Form.Item
            label={translate("editors.index_type_categories.code")}
            name={FormFields.CODE}
            initialValue={rowData?.code}
            className={"mb-0"}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.index_type_categories.required_messages",
                  {
                    field: translate("editors.index_type_categories.code")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col
          lg={2}
          sm={3}
          xs={4}
          style={{
            display: "flex",
            marginTop: 20,
            alignItems: "center"
          }}
        >
          <Form.Item
            label={translate("editors.index_type_categories.valid")}
            className={"png-form-item-horizontal-checkbox mb-0"}
            name={FormFields.VALID}
            valuePropName={"checked"}
            initialValue={rowData?.valid ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className={"content-section-modal-borderless pb-0"}>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.index_type_categories.name")}
            name={FormFields.NAME}
            initialValue={rowData?.name}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.index_type_categories.required_messages",
                  {
                    field: translate("editors.index_type_categories.name")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.index_type_categories.description")}
            name={FormFields.DESCRIPTION}
            initialValue={rowData?.description}
            className={"mb-0"}
          >
            <TextArea />
          </Form.Item>
        </Col>
        <Col>
          <div style={{ marginTop: "2em", marginBottom: "1em" }}>
            <label style={{ fontWeight: "bold", fontSize: "12px" }}>
              {translate("editors.index_type_categories.connection_candidates")}
            </label>
            {renderCategoryCandidates()}
          </div>
        </Col>
      </Row>
    </Form>
  );
};

export default IndexTypeCategoryForm;
